import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

export const CONSENT_KEY = "planiq_cookie_consent";
export const CONSENT_EVT = "planiq:consent-changed";

export function getConsent() {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
}

export function setConsent(v) {
  try {
    localStorage.setItem(CONSENT_KEY, v);
    window.dispatchEvent(new CustomEvent(CONSENT_EVT, { detail: v }));
  } catch { /* ignore */ }
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (!c) setVisible(true);
  }, []);

  const accept = (choice) => {
    setConsent(choice);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4 sm:px-6 sm:pb-6" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto rounded-2xl bg-slate-900 text-white shadow-xl border border-slate-800 p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center shrink-0">
          <Cookie className="h-5 w-5" />
        </div>
        <div className="flex-1 text-sm leading-relaxed">
          <p className="font-medium">Vi bruker cookies</p>
          <p className="mt-1 text-slate-300">
            Vi bruker nødvendige cookies for å holde deg innlogget, og valgfrie statistikk-cookies for å forbedre tjenesten.
            {" "}
            <Link to="/personvern" className="underline hover:text-white" data-testid="cookie-privacy-link">Les mer</Link>.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 shrink-0">
          <Button
            variant="outline"
            onClick={() => accept("necessary")}
            className="rounded-full border-white/20 text-white hover:bg-white/10 bg-transparent"
            data-testid="cookie-necessary-btn"
          >
            Kun nødvendige
          </Button>
          <Button
            onClick={() => accept("all")}
            className="rounded-full bg-white text-slate-900 hover:bg-slate-100"
            data-testid="cookie-accept-btn"
          >
            Godta alle
          </Button>
        </div>
      </div>
    </div>
  );
}
